import React from 'react';
import Footer from '../../components/footer/Footer';
import PageTitle from '../../components/pageTitle/PageTitle';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axiosRequest from '../../services/axios/axiosRequest';
import Loading from '../../components/loading/Loading';
import { Helmet } from 'react-helmet-async';
import styles from './products.module.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InventoryTable from '../../components/inventoryTable/InventoryTable';
import Header from '../../components/header/Header';
import DomPurify from 'dompurify';


const columns = [
  { field: 'row', headerName: '', flex: 0.5, disableColumnMenu: true, renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 },
  {
    field: 'image', headerName: 'نمایه', flex: 1, renderCell: (params) => {
      return <>{params.value && <img className={styles.image} src={params.value} alt={params.row.name} loading='lazy' />}</>
    }
  },
  { field: 'name', headerName: 'عنوان', flex: 5, },
  { field: 'volume', headerName: 'حجم', flex: 2, },
  { field: 'cat', headerName: 'Cat', flex: 2, },
  { field: 'cas', headerName: 'Cas', flex: 2, },
  { field: 'brand', headerName: 'کمپانی', flex: 3, },
];

export default function Products() {

  const { slug } = useParams();
  const navigateTo = useNavigate();
  const [brands, setBrands] = useState({});
  const [selectedBrand, setSelectedBrand] = useState('');
  const [inventory, setInventory] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isDataGridLoading, setIsDataGridLoading] = useState(false);

  useEffect(() => {
    const brandsController = new AbortController();
    axiosRequest.get(`/categories/${slug}/`, { signal: brandsController.signal })
      .then(res => setBrands(res.data))
      .catch(err => { if (err?.response?.data?.detail === "Not found.") navigateTo('/notFound') })
      .finally(() => setIsLoading(false));
    return () => brandsController.abort();
  }, []);

  function handleBrandClick(event) {
    setIsDataGridLoading(true);
    const chosenBrand = brands.results.find(brand => brand.name === event.target.value);
    setSelectedBrand(chosenBrand.name);
    axiosRequest.get(`/categories/${slug}/${chosenBrand.slug}/`, { signal: AbortSignal.timeout(10000) })
      .then(res => setInventory(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsDataGridLoading(false));
  }

  return (
    <>
      <Helmet>
        {isLoading ?
          <>
            <title>محصولات - نوآوران پژوه</title>
            <meta name='description' content="موجودی محصولات شرکت نوآوران پژوه" />
          </>
          :
          <>
            <title>{slug.replaceAll('-', ' ')} - نوآوران پژوه</title>
            <meta name='description' content={`موجودی ${slug.replaceAll('-', ' ')} ${selectedBrand} شرکت نوآوران پژوه`} />
          </>
        }
      </Helmet>

      <Header />

      <main className='mainContainer container-xl'>
        {isLoading ? <Loading /> :
          <>
            <PageTitle title={`${slug.replaceAll('-', ' ').toUpperCase()} ${selectedBrand}`} url={inventory?.url} views={inventory?.views} />

            <section className='d-flex flex-column align-items-center gap-4'>

              <FormControl sx={{ width: '250px', }}>
                <InputLabel sx={{ fontFamily: 'iranSans' }} id="demo-simple-select-label">انتخاب برند</InputLabel>
                <Select labelId="demo-simple-select-label" id="demo-simple-select"
                  value={selectedBrand}
                  label="انتخاب برند"
                  onChange={(event) => handleBrandClick(event)}
                  sx={{ direction: 'ltr', fontFamily: 'iranSans' }}
                >
                  {brands?.results?.sort((a, b) => a.name.localeCompare(b.name)).map(brand =>   // sorting brands before showing them
                    <MenuItem dir='ltr' value={brand.name} key={brand.id}>{brand.name}</MenuItem>
                  )}
                </Select>
              </FormControl>

              {selectedBrand &&
                <div className={styles.table_container}>
                  <InventoryTable rows={inventory?.results} columns={columns} isLoading={isDataGridLoading} />
                </div>
              }

              <div className={styles.description}
                dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(brands?.description) }}>
              </div>

            </section>
          </>
        }
      </main >

      <Footer />

    </>
  )
}
